var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',[_c('CommonSection',{attrs:{"title":_vm.$route.params.projectId ? 'Редактирование проекта' : 'Новый проект'}},[_c('ProjectForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }